<template>
  <div id="default-movie">
    <div
      class="videoOverlay"
      :class="{ activeVideo: defaultMoviePlayFlag }"
      @click="handlePlayVideo"
    >
      <button v-if="!defaultMoviePlayFlag" class="player-btn"></button>
    </div>
    <div class="slideshow-container" v-show="defaultMoviePlayFlag">
      <iframe
        :src="
          `http://localhost:8081/api/memorialone/v1/obituary/movie?obituaryId=${id}`
        "
        frameborder="0"
      >
      </iframe>
    </div>

    <audio ref="movieMusicplayer">
      <source
        src="http://coco.daqda.kr/Theme/T84/T84_Audio.mp3"
        type="audio/mpeg"
      />
    </audio>
  </div>
</template>

<script>
import { $JssorSlider$, $JssorEasing$ } from "jssor-slider";

export default {
  name: "Slider",
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : null,

      defaultMoviePlayFlag: false
    };
  },
  methods: {
    handlePlayVideo() {
      this.defaultMoviePlayFlag = !this.defaultMoviePlayFlag;
      const movieMusicplayer = this.$refs.movieMusicplayer;

      console.log(this.$refs.movieMusicplayer);

      if (this.defaultMoviePlayFlag) {
        movieMusicplayer.play();

        this.$emit("defualtMovieplayMusic");
      } else {
        movieMusicplayer.pause();
      }
    }
  }
};
</script>
<style>
#default-movie {
  position: relative;
}
.videoOverlay {
  background: url("../../assets/images/obituary/preview-test.png") no-repeat;
  background-size: cover;
  width: 100%;
  max-width: 420px;
  height: 225px;
  position: initial;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}

.videoOverlay .player-btn {
  background: url("../../assets/icons/player_icon.png") no-repeat;

  width: 70px;
  height: 70px;

  cursor: pointer;
}

.videoOverlay.activeVideo {
  background: transparent;
  width: 100%;
  max-width: 420px;
  height: 225px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.slideshow-container {
  width: 100%;
  max-width: 420px;
}

.slideshow-container iframe {
  width: 100%;
  height: 225px;
}
</style>
